// extracted by mini-css-extract-plugin
export default {"button":"Companies_button__N2nq5","orderHeader":"Companies_orderHeader__3duhv"};